// Function to hide the fieldset based on the legend text
  const videoMediaElement = document.querySelector('video-media');

  if (videoMediaElement) {
    videoMediaElement.addEventListener('click', function() {
      // Redirect to the target page on click
      window.location.href = "/collections/bestsellers";
    });
  }

function hideQuickAddButton() {
    const quickAddButtons = document.querySelectorAll('.product-card__quick-add-button');
    quickAddButtons.forEach(button => {
        button.style.display = 'none';
    });
}

// Initial call to hide buttons
hideQuickAddButton();

// Set up a MutationObserver to watch for dynamically added buttons
const observer = new MutationObserver(() => hideQuickAddButton());
observer.observe(document.body, { childList: true, subtree: true });


// document.addEventListener('click', (event) => {
//     if (event.target.closest('.product-card__quick-add-button')) { 
//         console.log("INSIDE product-card__quick-add-button");

//         const modalObserver = new MutationObserver((mutationsList, observer) => {
//             const modalContent = document.querySelector('.quick-buy-modal__content');
            
//             if (modalContent) {
//                 observer.disconnect(); // Stop observing the body once modal content is found
                
//                 // Apply styles initially and on any content change within modal
//                 const applyStyles = () => {
//                     const fieldsets = modalContent.querySelectorAll('fieldset');
//                     fieldsets.forEach(fieldset => {
//                         const legend = fieldset.querySelector('legend');
//                         if (legend && legend.textContent.toLowerCase().includes('season')) {
//                             fieldset.style.display = 'none';
//                         }

//                         const labels = fieldset.querySelectorAll('label');
//                         labels.forEach(label => {
//                             if (label.classList.contains('is-disabled')) {
//                                 label.style.display = 'none';
//                             }
//                         });
//                     });
//                 };

//                 // Apply styles initially
//                 applyStyles();

//                 // Create a new observer for changes within the modal content
//                 const contentObserver = new MutationObserver(() => applyStyles());
//                 contentObserver.observe(modalContent, { childList: true, subtree: true });
//             }
//         });

//         modalObserver.observe(document.body, { childList: true, subtree: true });
//     }
// });

// Add click event listener to the quick-add button
// document.addEventListener('DOMContentLoaded', () => {
//   console.log('INSIDE DOMContentLoaded');
// document.querySelectorAll('.product-card__quick-add-button').forEach(button => {
//     button.addEventListener('click', () => {
//       console.log("INSIDE product-card__quick-add-button");
//         // Start observing the DOM for changes product-card__quick-add-button
      
//         const observer = new MutationObserver((mutationsList, observer) => {
//             const modalContent = document.querySelector('.quick-buy-modal__content');
            
//             if (modalContent) {
//                 // Stop observing once the modal is found
//                 observer.disconnect();

//                 // Select all fieldsets within the modal
//                 const fieldsets = modalContent.querySelectorAll('fieldset');

//                 fieldsets.forEach(fieldset => {
//                     const legend = fieldset.querySelector('legend');
                    
//                     if (legend && legend.textContent.toLowerCase().includes('season')) {
//                         fieldset.style.display = 'none';
//                     }

//                     const labels = fieldset.querySelectorAll('label');
//                     labels.forEach(label => {
//                         if (label.classList.contains('is-disabled')) {
//                             label.style.display = 'none';
//                         }
//                     });
//                 });
//             }
//         });

//         // Observe the body for added child nodes (like the modal content)
//         observer.observe(document.body, { childList: true, subtree: true });
//     });
// });
// });

const hideSeasonFieldset = () => {
  // Check if the current URL contains '/products'
  if (window.location.pathname.includes('/products')) {
    // Find all fieldsets on the page
    const fieldsets = document.querySelectorAll('fieldset');
    
    // Loop through each fieldset
    fieldsets.forEach((fieldset) => {
      // Find the <legend> element inside the fieldset
      const legend = fieldset.querySelector('legend');
      
      // Check if the legend contains the text "season"
      if (legend && legend.textContent.toLowerCase().includes('season')) {
        // Hide the fieldset
          fieldset.style.display = 'none';
      }
      const labels = fieldset.querySelectorAll('label');
      labels.forEach((label) => {
        if (label.classList.contains('is-disabled')) {
          label.style.display = 'none';  // Hide the 'Black' label immediately
        }
        // console.log("Label: " + label.classList);
      });
    });
  }
};

// Observe changes to the <product-rerender> element
const observeProductRerender = () => {
  const productRerenderElement = document.querySelector('product-rerender');

  if (productRerenderElement) {
    const observer = new MutationObserver(() => {
      // Reapply hiding logic when the <product-rerender> element is updated
      hideSeasonFieldset();
    });

    // Start observing for child changes (i.e., re-renders)
    observer.observe(productRerenderElement, {
      childList: true,  // Look for changes to children (i.e., re-rendering)
      subtree: true     // Observe changes in all descendant nodes
    });
  }
};

// Run the hideSeasonFieldset initially
hideSeasonFieldset();

// Observe the <product-rerender> element
observeProductRerender();

// const hideSeasonFieldset = () => {
//   document.addEventListener("DOMContentLoaded", function() {
//   if (window.location.pathname.includes('/products')) {
//     async function load() {
//       // Check if Shopify object is available
//       if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
//         try {
//           // Fetch browsing context suggestions based on country and language
//           let response = await fetch(window.Shopify.routes.root + 
//             'browsing_context_suggestions.json' + 
//             '?country[enabled]=true' + 
//             '&country[exclude]=' + window.Shopify.country + 
//             '&language[enabled]=true' + 
//             '&language[exclude]=' + window.Shopify.language
//           );
//           let obj = await response.json();
          
//           // Use the detected country
//           let countryName = obj.detected_values && obj.detected_values.country_name;
//           window.console.log(countryName);

//           // Hide fieldset logic
//           const hideColorFieldset = () => {
//             const fieldsets = document.querySelectorAll('fieldset');
//             fieldsets.forEach((fieldset) => {
//               const legend = fieldset.querySelector('legend');
//               if (legend && legend.textContent.toLowerCase().includes('color')) {
//                 const labels = fieldset.querySelectorAll('label');
//                 labels.forEach((label) => {
//                   if (label.textContent.trim() === 'Black') {
//                     label.style.display = 'none';  // Hide the 'Black' label immediately
//                   }
//                   // console.log("Label text: " + label.textContent.trim());
//                 });
//               }
//             });
//           };

//           // Apply hiding logic immediately
//           hideColorFieldset();

//           // Observe changes in product details to reapply hiding logic
//           observeProductRerender(hideColorFieldset);

//         } catch (error) {
//           console.error('Error fetching browsing context:', error);
//         }
//       } else {
//         console.error('Shopify routes or country/language not available');
//       }
//     }
  
//     load();
//   }
//   });
// };

// const observeProductRerender = (callback) => {
//   const productRerenderElement = document.querySelector('product-rerender');

//   if (productRerenderElement) {
//     const observer = new MutationObserver(() => {
//       // Apply hiding logic when <product-rerender> is updated
//       callback();  // Reapply hide logic
//     });

//     observer.observe(productRerenderElement, {
//       childList: true, // Observe children for changes
//       subtree: true    // Observe descendants
//     });
//   }
// };

// // Run the hideSeasonFieldset initially
// hideSeasonFieldset();
